export const TOURNAMENT_ACTIONS = {
  update: {
    request: "TOURNAMENT/UPDATE_REQUEST",
    success: "TOURNAMENT/UPDATE_SUCCESS",
    error: "TOURNAMENT/UPDATE_ERROR",
  },
};
